import React from 'react';
import { RouteProp, useRoute } from '@react-navigation/native';
import { UserParamList } from '../../typings/Params';
import MaintenanceRequestComponent from '../crm/MaintenanceRequests/MaintenanceRequestComponent';
import { RootNavigation } from '../../Routes';

export default function GetOwnMaintenanceRequest({ navigation }: {
    navigation: RootNavigation;
}) {
    const route = useRoute<RouteProp<UserParamList, 'GetOwnMaintenanceRequest'>>();
    return <MaintenanceRequestComponent navigation={navigation} route={route} page={'own-maintenance-requests'} />;
}
